import { createSearchParams } from 'react-router-dom'
import { GetTenantSearchData } from '../../apis/types'

/** Fields that map a search hit to a specific tenant account (not the tenant as a whole). */
const ACCOUNT_SPECIFIC_MATCH_FIELDS = new Set([
  'tenantAccountNumber',
  'tenantAccountName',
  'tenantAccountCuid',
  'utilityAccountNumber',
  'utilityAccountName',
  'meterNumber',
  'meterCuid',
  'meterServiceCuid',
  'serviceAccountId',
  'serviceStreetAddress',
  'billingStreetAddress',
  'mailingStreetAddress',
  'accountManagerIdentifier',
  'accountManagerFullName',
  'accountManagerPhone',
])

export const isAccountSpecificMatch = (matchedOn: string[] | undefined | null): boolean => {
  if (matchedOn == null || matchedOn.length === 0) return false
  return matchedOn.some((field) => ACCOUNT_SPECIFIC_MATCH_FIELDS.has(field))
}

export type TenantSearchHref = {
  pathname: string
  search?: string
}

/**
 * Build the navigation target for a TENANT search result.
 * Account-specific matches deep-link with ?serviceAccountNumber= so Tenant.tsx can highlight.
 * Tenant-level matches (e.g. contact) navigate to the tenant page without highlighting.
 */
export const getTenantSearchHref = (
  selection: Pick<GetTenantSearchData, 'tenantCuid' | 'tenantAccountNumber' | 'matchedOn'>
): TenantSearchHref => {
  const pathname = `/tenant/tenants/${selection.tenantCuid as string}`

  if (
    selection.tenantAccountNumber &&
    isAccountSpecificMatch(selection.matchedOn)
  ) {
    return {
      pathname,
      search: `?${createSearchParams({
        serviceAccountNumber: String(selection.tenantAccountNumber),
      }).toString()}`,
    }
  }

  return { pathname }
}
